import { timeAgo } from "@/format/time";
import { type PlainMessage, Timestamp } from "@bufbuild/protobuf";
import type { FC } from "react";

const timeAgoFormat = new Intl.RelativeTimeFormat("en", {
    style: "long",
});

export const CreationTime: FC<{ timestamp?: PlainMessage<Timestamp> }> = ({ timestamp }) => {
    if (!timestamp) {
        return null;
    }
    const date = new Timestamp(timestamp).toDate();
    const relative = timeAgo(date, timeAgoFormat);
    return <span title={date.toISOString()}>{relative}</span>;
};
